import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../../../../../config/config';
import { getEnv } from '../../../../../modules/utility';
import { BaseHttpService } from 'src/app/shared/base-http/base-http.service';
import { PageOptions } from 'src/app/shared/data-table/data-table.interface';

interface Program {
   id: number;
   programName: string;
}

@Injectable({
   providedIn: 'root'
})
export class ProgramMaintenanceService {

   constructor(
      private readonly baseHttpService: BaseHttpService
   ) { }

   public getPrograms(programNameFilter, pageOptions?: PageOptions): Observable<{ data: Program[], totalCount: number }> {
      pageOptions = pageOptions || {
         page: 0,
         order: 'asc',
         size: 10,
         sort: 'programName'
      };

      const params = this.baseHttpService.generateHttpParams({
         page: pageOptions.page,
         size: pageOptions.size,
         sort: pageOptions.sort,
         order: pageOptions.order,
         programNameFilter: programNameFilter
      });
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/program`;
      return this.baseHttpService.get(url, { params: params });
   }

   public getUnAssociatedMescPrograms(): Observable<any> {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/program/mesc`;
      return this.baseHttpService.get(url);
   }

   public updateProgram(body: Program) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/program`;
      return this.baseHttpService.put(url, body);
   }

   /**
    * Add unassociated MESC program to TPRECM programs
    *
    * @param {*} url
    * @param {*} body
    * @memberof ProgramMaintenanceService
    */
   public associateMescProgram(body) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/program/mesc`;
      return this.baseHttpService.post(url, body);
   }

   public addToolTemplates(body) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/tool-template`;
      return this.baseHttpService.post(url, body);
   }
}
